<template>
  <div class="employee">
    <h2>{{ employee.name }}</h2>
    <div class="employee__data">
      <p>{{ employee.tag }}</p>
      <p>{{ employee.phone }}</p>
      <p>
        <a :href="'mailto:' + employee.mail">{{ employee.mail }}</a>
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  employee: {
    type: Object,
    default: () => ({
      name: String,
      tag: String,
      phone: String,
      mail: String,
    }),
  },
});
</script>

<style scoped lang="scss">
.employee {
  width: 100%;
  border-bottom: 2px solid $btn--border;
  padding: map-get($spaces, "md") 0;
  .employee__data {
    display: flex;
    flex-direction: column;
    gap: map-get($spaces, "xxs");
  }
  h2 {
    margin-bottom: map-get($spaces, "xs");
  }
  p,
  a {
    color: $text--greyed;
    font-size: 1.3rem;
    font-weight: 400;
  }
}
</style>
